import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

// Professional Vector SVG Icon Components
const IconMail = ({ size = 20, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="3"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
);
const IconHeart = ({ size = 20, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>
);
const IconCamera = ({ size = 20, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>
);
const IconCalendar = ({ size = 20, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
);
const IconNewspaper = ({ size = 20, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8M15 18h-5M10 6h8v4h-8z"/></svg>
);
const IconBell = ({ size = 20, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
);
const IconEye = ({ size = 18, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
);
const IconTrash = ({ size = 18, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2M10 11v6M14 11v6"/></svg>
);
const IconPencil = ({ size = 18, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>
);
const IconPlus = ({ size = 18, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"/></svg>
);
const IconCloudUpload = ({ size = 28, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"/><path d="M12 12v9M16 16l-4-4-4 4"/></svg>
);
const IconTest = ({ size = 18, color = 'currentColor' }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 3h6M10 3v6.2L4.4 19A2 2 0 0 0 6.1 22h11.8a2 2 0 0 0 1.7-3L14 9.2V3"/><path d="M8.5 15h7"/></svg>
);

const sections = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'contacts', label: 'Contact Us & Mail' },
  { id: 'donations', label: 'Donation Inquiries' },
  { id: 'gallery', label: 'Gallery Management' },
  { id: 'past-events', label: 'Past Activities' },
  { id: 'events', label: 'Upcoming Events' },
  { id: 'press', label: 'Press Releases' },
  { id: 'settings', label: 'Site Settings' },
];

function renderIcon(id) {
  const props = {
    width: 18,
    height: 18,
    strokeWidth: 2.2,
    stroke: 'currentColor',
    fill: 'none',
    style: { marginRight: 12, flexShrink: 0 }
  };
  switch (id) {
    case 'dashboard':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="3" width="7" height="9" rx="1" />
          <rect x="14" y="3" width="7" height="5" rx="1" />
          <rect x="14" y="12" width="7" height="9" rx="1" />
          <rect x="3" y="16" width="7" height="5" rx="1" />
        </svg>
      );
    case 'contacts':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      );
    case 'donations':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      );
    case 'gallery':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
      );
    case 'events':
    case 'past-events':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      );
    case 'press':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <path d="M16 8h2M16 12h2M8 8h5M8 12h5M8 16h10" />
        </svg>
      );
    case 'settings':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      );
    case 'website':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      );
    case 'lock':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      );
    default:
      return null;
  }
}

function Admin() {
  const [authorized, setAuthorized] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  const [section, setSection] = useState('dashboard');
  const [stats, setStats] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [donations, setDonations] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [events, setEvents] = useState([]);
  const [press, setPress] = useState([]);
  const [settings, setSettings] = useState({
    phone: '',
    email: '',
    address: '',
    whatsapp: '',
    hours: '',
    googleMapsUrl: '',
    facebookUrl: '',
    instagramUrl: '',
    youtubeUrl: '',
    bankName: '',
    bankAccountName: '',
    bankAccountNumber: '',
    bankIban: '',
    bankSwift: '',
    donationMessage: '',
    notificationEmail: '',
    enableEmailNotification: true,
    enableUserConfirmation: true,
    smtpHost: '',
    smtpPort: 587,
    smtpUser: '',
    smtpPass: '',
    smtpSecure: false,
  });

  const [contactFilter, setContactFilter] = useState('all');
  const [selectedContactModal, setSelectedContactModal] = useState(null);
  const [replyModal, setReplyModal] = useState({ open: false, contact: null, subject: '', message: '', sending: false, error: '', success: '' });
  const [testEmailModal, setTestEmailModal] = useState({ open: false, targetEmail: '', sending: false, result: '', error: '' });

  // Change-password form state
  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [pwMessage, setPwMessage] = useState('');

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  // Editing States
  const [editingId, setEditingId] = useState(null);

  // Forms
  const [galleryForm, setGalleryForm] = useState({ title: '', category: 'Facility', emoji: '📸', imageUrl: '' });
  const [eventForm, setEventForm] = useState({ title: '', description: '', date: '', location: '', emoji: '📅', imageUrl: '', type: 'future' });
  const [pressForm, setPressForm] = useState({ title: '', summary: '', content: '', date: '', emoji: '📰', imageUrl: '' });

  const openReplyModal = (contactItem) => {
    setReplyModal({
      open: true,
      contact: contactItem,
      subject: `Re: Medical Inquiry (${contactItem.service}) - Mega Health Group`,
      message: `Dear ${contactItem.firstName},\n\nThank you for reaching out to Mega Health Group regarding your request for ${contactItem.service}.\n\n`,
      sending: false,
      error: '',
      success: ''
    });
  };

  const handleSendReply = async (e) => {
    e.preventDefault();
    if (!replyModal.contact) return;
    setReplyModal(r => ({ ...r, sending: true, error: '', success: '' }));
    try {
      await api.post(`/contact/${replyModal.contact.id || replyModal.contact._id}/reply`, {
        subject: replyModal.subject,
        message: replyModal.message
      });
      setReplyModal(r => ({ ...r, sending: false, success: '✓ Reply email sent successfully!' }));
      setTimeout(() => {
        setReplyModal({ open: false, contact: null, subject: '', message: '', sending: false, error: '', success: '' });
        loadAll();
      }, 1500);
    } catch (err) {
      setReplyModal(r => ({ ...r, sending: false, error: err.response?.data?.message || 'Failed to send email reply.' }));
    }
  };

  const handleSendTestEmail = async (e) => {
    e.preventDefault();
    if (!testEmailModal.targetEmail) return;
    setTestEmailModal(t => ({ ...t, sending: true, result: '', error: '' }));
    try {
      const res = await api.post('/settings/test-email', { targetEmail: testEmailModal.targetEmail });
      setTestEmailModal(t => ({ ...t, sending: false, result: res.data.message || 'Test email dispatched successfully!' }));
    } catch (err) {
      setTestEmailModal(t => ({ ...t, sending: false, error: err.response?.data?.message || 'Failed to send test email.' }));
    }
  };

  // On mount: verify stored token via the backend
  useEffect(() => {
    const token = localStorage.getItem('megaAdminToken');
    if (!token) {
      setLoading(false);
      return;
    }
    api.post('/login?action=verify', { token })
      .then(res => {
        if (res.data.valid) {
          setAuthorized(true);
          loadAll();
        } else {
          localStorage.removeItem('megaAdminToken');
          setLoading(false);
        }
      })
      .catch(() => {
        localStorage.removeItem('megaAdminToken');
        setLoading(false);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUnlock = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setLoginError('');
    try {
      const res = await api.post('/login', { username, password });
      localStorage.setItem('megaAdminToken', res.data.token);
      setAuthorized(true);
      setUsername('');
      setPassword('');
      loadAll();
    } catch (err) {
      const msg = err.response?.data?.message || 'Login failed. Check your credentials.';
      setLoginError(msg);
    } finally {
      setLoginLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('megaAdminToken');
    setAuthorized(false);
    setUsername('');
    setPassword('');
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPwMessage('');
    if (pwForm.newPassword !== pwForm.confirmPassword) {
      setPwMessage('New passwords do not match.');
      return;
    }
    if (pwForm.newPassword.length < 8) {
      setPwMessage('New password must be at least 8 characters.');
      return;
    }
    try {
      const token = localStorage.getItem('megaAdminToken');
      const res = await api.post('/login?action=change-password', {
        token,
        currentPassword: pwForm.currentPassword,
        newPassword: pwForm.newPassword,
      });
      // Store the refreshed token
      localStorage.setItem('megaAdminToken', res.data.token);
      setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setPwMessage('✓ Password changed successfully!');
    } catch (err) {
      setPwMessage(err.response?.data?.message || 'Failed to change password.');
    }
  };

  async function loadAll() {
    setLoading(true);
    try {
      const [statsRes, contactsRes, donationsRes, galleryRes, eventsRes, pressRes, settingsRes] = await Promise.all([
        api.get('/admin'),
        api.get('/contact'),
        api.get('/donation'),
        api.get('/gallery/all'),
        api.get('/events/all'),
        api.get('/press/all'),
        api.get('/settings'),
      ]);
      setStats(statsRes.data);
      setContacts(Array.isArray(contactsRes.data) ? contactsRes.data : []);
      setDonations(Array.isArray(donationsRes.data) ? donationsRes.data : []);
      setGallery(Array.isArray(galleryRes.data) ? galleryRes.data : []);
      setEvents(Array.isArray(eventsRes.data) ? eventsRes.data : []);
      setPress(Array.isArray(pressRes.data) ? pressRes.data : []);
      if (settingsRes.data) {
        setSettings(settingsRes.data);
      }
    } catch (err) {
      console.error(err);
      setMessage('Unable to load administration records. Ensure the PHP backend is active.');
    } finally {
      setLoading(false);
    }
  }

  // File to Base64 Reader Utility
  const handleImageUpload = (e, setFormCallback) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormCallback(f => ({ ...f, imageUrl: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  // CRUD Submissions
  async function handleGallerySubmit(e) {
    e.preventDefault();
    try {
      if (editingId) {
        await api.put(`/gallery/${editingId}`, galleryForm);
        setMessage('Gallery item updated.');
      } else {
        await api.post('/gallery', galleryForm);
        setMessage('Gallery item created successfully.');
      }
      setGalleryForm({ title: '', category: 'Facility', emoji: '📸', imageUrl: '' });
      setEditingId(null);
      loadAll();
    } catch {
      setMessage('Failed to save gallery item.');
    }
  }

  async function handleEventSubmit(e) {
    e.preventDefault();
    try {
      // Force the type based on the active section to ensure correctness
      const payload = { ...eventForm, type: section === 'past-events' ? 'past' : 'future' };
      if (editingId) {
        await api.put(`/events/${editingId}`, payload);
        setMessage('Event item updated.');
      } else {
        await api.post('/events', payload);
        setMessage('Event item created successfully.');
      }
      setEventForm({ title: '', description: '', date: '', location: '', emoji: '📅', imageUrl: '', type: section === 'past-events' ? 'past' : 'future' });
      setEditingId(null);
      loadAll();
    } catch {
      setMessage('Failed to save event.');
    }
  }

  async function handlePressSubmit(e) {
    e.preventDefault();
    try {
      if (editingId) {
        await api.put(`/press/${editingId}`, pressForm);
        setMessage('Press release updated.');
      } else {
        await api.post('/press', pressForm);
        setMessage('Press release created successfully.');
      }
      setPressForm({ title: '', summary: '', content: '', date: '', emoji: '📰', imageUrl: '' });
      setEditingId(null);
      loadAll();
    } catch {
      setMessage('Failed to save press release.');
    }
  }

  async function handleSettingsSubmit(e) {
    e.preventDefault();
    try {
      await api.put('/settings', settings);
      setMessage('Site settings updated successfully.');
      loadAll();
    } catch {
      setMessage('Failed to save site settings.');
    }
  }

  // Delete Action
  async function deleteItem(type, id) {
    if (!window.confirm('Are you sure you want to delete this record?')) return;
    try {
      await api.delete(`/${type}/${id}`);
      setMessage('Record deleted.');
      loadAll();
    } catch {
      setMessage('Failed to delete item.');
    }
  }

  // Toggle statuses
  async function toggleContactStatus(id, currentStatus) {
    const nextStatus = currentStatus === 'new' ? 'read' : 'new';
    try {
      await api.patch(`/contact/${id}/status`, { status: nextStatus });
      setMessage('Contact status updated.');
      loadAll();
    } catch {
      setMessage('Failed to update status.');
    }
  }

  async function toggleDonationStatus(id, currentStatus) {
    const nextStatus = currentStatus === 'new' ? 'read' : 'new';
    try {
      await api.patch(`/donation/${id}/status`, { status: nextStatus });
      setMessage('Donation status updated.');
      loadAll();
    } catch {
      setMessage('Failed to update status.');
    }
  }

  // Edit Initiations
  const startEditGallery = (item) => {
    setEditingId(item.id || item._id);
    setGalleryForm({ title: item.title, category: item.category, emoji: item.emoji || '📸', imageUrl: item.imageUrl || '' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const startEditEvent = (item) => {
    setEditingId(item.id || item._id);
    setEventForm({ title: item.title, description: item.description, date: item.date, location: item.location || '', emoji: item.emoji || '📅', imageUrl: item.imageUrl || '', type: item.type || 'future' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const startEditPress = (item) => {
    setEditingId(item.id || item._id);
    setPressForm({ title: item.title, summary: item.summary, content: item.content || '', date: item.date, emoji: item.emoji || '📰', imageUrl: item.imageUrl || '' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setGalleryForm({ title: '', category: 'Facility', emoji: '📸', imageUrl: '' });
    setEventForm({ title: '', description: '', date: '', location: '', emoji: '📅', imageUrl: '', type: section === 'past-events' ? 'past' : 'future' });
    setPressForm({ title: '', summary: '', content: '', date: '', emoji: '📰', imageUrl: '' });
  };

  // Locked Login Screen
  if (!authorized) {
    return (
      <div className="lock-screen-wrapper">
        <div className="lock-card">
          <div className="lock-icon-badge">
            <svg viewBox="0 0 24 24" width="36" height="36" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              <circle cx="12" cy="16" r="1.5" fill="currentColor" />
            </svg>
          </div>
          <h2>Admin Console</h2>
          <p style={{ fontSize: '0.88rem', color: '#64748B', margin: '4px 0 28px' }}>
            Mega Health Group Management Dashboard
          </p>
          <form onSubmit={handleUnlock}>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: 16 }}>
              <label style={{ fontSize: '0.82rem', fontWeight: 700, color: '#334155', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username..."
                required
                autoComplete="username"
                style={{ borderRadius: 12, padding: '12px 16px', background: '#F8FAFC', border: '1px solid #E2E8F0', width: '100%', fontSize: '0.95rem' }}
              />
            </div>
            <div className="form-group" style={{ textAlign: 'left', marginBottom: 20 }}>
              <label style={{ fontSize: '0.82rem', fontWeight: 700, color: '#334155', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password..."
                required
                autoComplete="current-password"
                style={{ borderRadius: 12, padding: '12px 16px', background: '#F8FAFC', border: '1px solid #E2E8F0', width: '100%', fontSize: '0.95rem', letterSpacing: '0.15em' }}
              />
            </div>
            {loginError && <p style={{ color: 'var(--danger)', fontSize: '0.88rem', margin: '0 0 16px', fontWeight: 600 }}>{loginError}</p>}
            <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '13px', borderRadius: 12, fontSize: '0.95rem', fontWeight: 700, background: 'var(--admin-accent-gradient)', boxShadow: '0 4px 14px rgba(15, 118, 110, 0.35)' }} disabled={loginLoading}>
              {loginLoading ? 'Authenticating...' : 'Unlock Dashboard'}
            </button>
            <div style={{ marginTop: 24 }}>
              <Link to="/" style={{ fontSize: '0.88rem', color: 'var(--teal-primary)', fontWeight: 600, textDecoration: 'none' }}>← Return to Homepage</Link>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      {/* Sidebar navigation */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <div className="admin-brand-badge">
            <svg viewBox="0 0 24 24" width="24" height="24" stroke="#D4AF37" strokeWidth="2.5" fill="none"><path d="M12 5v14M5 12h14"/></svg>
          </div>
          <div>
            <div className="brand">Mega Health</div>
            <div className="sub">Admin Console</div>
          </div>
        </div>

        <div className="admin-nav-group-label">Navigation</div>
        <nav className="admin-nav">
          {sections.map(item => (
            <button
              key={item.id}
              type="button"
              className={`admin-nav-link ${section === item.id ? 'active' : ''}`}
              onClick={() => {
                setSection(item.id);
                cancelEdit();
                if (item.id === 'events') setEventForm(f => ({...f, type: 'future'}));
                if (item.id === 'past-events') setEventForm(f => ({...f, type: 'past'}));
                setMessage('');
              }}
            >
              {renderIcon(item.id)}
              <span>{item.label}</span>
              {item.id === 'contacts' && contacts.filter(c => c.status === 'new').length > 0 && (
                <span className="admin-nav-badge">{contacts.filter(c => c.status === 'new').length}</span>
              )}
            </button>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <Link to="/" className="admin-nav-link" style={{ justifyContent: 'center', background: 'rgba(255,255,255,0.06)', padding: '8px 10px', fontSize: '0.78rem' }}>
              🌐 Site
            </Link>
            <button onClick={handleLogout} className="admin-nav-link" style={{ justifyContent: 'center', background: 'rgba(239,68,68,0.2)', color: '#FCA5A5', padding: '8px 10px', fontSize: '0.78rem' }}>
              🔒 Lock
            </button>
          </div>
        </div>
      </aside>

      {/* Main Panel Content */}
      <main className="admin-main">
        <div className="admin-topbar">
          <div className="admin-topbar-title">
            <h1>{sections.find(s => s.id === section)?.label}</h1>
            <div className="admin-topbar-breadcrumb">
              Mega Health Group / Admin Console / {sections.find(s => s.id === section)?.label}
            </div>
          </div>
          <div className="admin-topbar-actions">
            <div className="admin-status-pill">
              <span className="admin-status-dot"></span>
              Live System Active
            </div>
          </div>
        </div>

        {message && (
          <div className="admin-message">
            <span>{message}</span>
            <span className="close" onClick={() => setMessage('')}>✕</span>
          </div>
        )}
        
        {loading && <p style={{ fontSize: '1.1rem', color: 'var(--muted)' }}>Retrieving data records...</p>}

        {/* Dashboard Modules */}
        {!loading && section === 'dashboard' && stats && (
          <div>
            <div className="admin-stats-grid">
              <div className="admin-stat-card">
                <div>
                  <div className="admin-stat-number">{stats.counts.contacts}</div>
                  <div className="admin-stat-label">Contact Enquiries</div>
                </div>
                <div className="admin-stat-icon">
                  <IconMail size={22} color="#0F766E" />
                </div>
              </div>
              <div className="admin-stat-card">
                <div>
                  <div className="admin-stat-number">{stats.counts.donations}</div>
                  <div className="admin-stat-label">Donation Inquiries</div>
                </div>
                <div className="admin-stat-icon">
                  <IconHeart size={22} color="#0F766E" />
                </div>
              </div>
              <div className="admin-stat-card">
                <div>
                  <div className="admin-stat-number">{stats.counts.gallery}</div>
                  <div className="admin-stat-label">Gallery Items</div>
                </div>
                <div className="admin-stat-icon">
                  <IconCamera size={22} color="#0F766E" />
                </div>
              </div>
              <div className="admin-stat-card">
                <div>
                  <div className="admin-stat-number">{stats.counts.events}</div>
                  <div className="admin-stat-label">Health Events</div>
                </div>
                <div className="admin-stat-icon">
                  <IconCalendar size={22} color="#0F766E" />
                </div>
              </div>
              <div className="admin-stat-card">
                <div>
                  <div className="admin-stat-number">{stats.counts.press}</div>
                  <div className="admin-stat-label">Press Releases</div>
                </div>
                <div className="admin-stat-icon">
                  <IconNewspaper size={22} color="#0F766E" />
                </div>
              </div>
              <div className="admin-stat-card gold">
                <div>
                  <div className="admin-stat-number" style={{ color: '#D4AF37' }}>
                    {stats.counts.newContacts + stats.counts.newDonations}
                  </div>
                  <div className="admin-stat-label" style={{ color: '#92400E' }}>New Submissions</div>
                </div>
                <div className="admin-stat-icon" style={{ background: '#FEF3C7', color: '#D4AF37' }}>
                  <IconBell size={22} color="#B89628" />
                </div>
              </div>
            </div>

            <div className="grid-2">
              <div className="card" style={{ padding: 24 }}>
                <h3 style={{ fontSize: '1.25rem', marginBottom: 16 }}>Recent Enquiries</h3>
                {contacts.length === 0 ? (
                  <p style={{ fontSize: '0.88rem' }}>No enquiries submitted yet.</p>
                ) : (
                  <div style={{ display: 'grid', gap: 12 }}>
                    {contacts.slice(0, 5).map(c => (
                      <div key={c.id || c._id} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid var(--border)', paddingBottom: 8, fontSize: '0.88rem' }}>
                        <div>
                          <strong>{c.firstName} {c.lastName}</strong> ({c.service})
                        </div>
                        <span style={{ background: c.status === 'new' ? 'var(--gold-light)' : 'var(--teal-soft)', padding: '2px 8px', borderRadius: 4, fontSize: '0.72rem', fontWeight: 700 }}>
                          {c.status}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="card" style={{ padding: 24 }}>
                <h3 style={{ fontSize: '1.25rem', marginBottom: 16 }}>Recent Donations</h3>
                {donations.length === 0 ? (
                  <p style={{ fontSize: '0.88rem' }}>No donation inquiries submitted yet.</p>
                ) : (
                  <div style={{ display: 'grid', gap: 12 }}>
                    {donations.slice(0, 5).map(d => (
                      <div key={d.id || d._id} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid var(--border)', paddingBottom: 8, fontSize: '0.88rem' }}>
                        <div>
                          <strong>{d.name}</strong> ({d.amount || 'Custom'})
                        </div>
                        <span style={{ background: d.status === 'new' ? 'var(--gold-light)' : 'var(--teal-soft)', padding: '2px 8px', borderRadius: 4, fontSize: '0.72rem', fontWeight: 700 }}>
                          {d.status}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Contact Us Management & Mail Hub */}
        {!loading && section === 'contacts' && (
          <div style={{ display: 'grid', gap: 30 }}>
            
            {/* Top Summary & Quick Actions */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
              <div className="card" style={{ padding: 20 }}>
                <h4 style={{ margin: '0 0 6px 0', fontSize: '0.82rem', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Total Enquiries</h4>
                <div style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--teal-dark)' }}>{contacts.length}</div>
              </div>
              <div className="card" style={{ padding: 20, background: 'var(--gold-light)' }}>
                <h4 style={{ margin: '0 0 6px 0', fontSize: '0.82rem', color: 'var(--dark)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>New / Unread</h4>
                <div style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--teal-dark)' }}>
                  {contacts.filter(c => c.status === 'new').length}
                </div>
              </div>
              <div className="card" style={{ padding: 20, background: 'var(--teal-soft)' }}>
                <h4 style={{ margin: '0 0 6px 0', fontSize: '0.82rem', color: 'var(--teal-primary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Replied</h4>
                <div style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--teal-primary)' }}>
                  {contacts.filter(c => c.status === 'replied').length}
                </div>
              </div>
              <div className="card" style={{ padding: 20, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{ fontSize: '0.78rem', color: 'var(--muted)', fontWeight: 600 }}>NOTIFICATION RECIPIENT</div>
                <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--teal-dark)', wordBreak: 'break-all' }}>
                  {settings.notificationEmail || settings.email || 'info@megahealthgroup.org'}
                </div>
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  style={{ marginTop: 10, alignSelf: 'flex-start' }}
                  onClick={() => setTestEmailModal({ open: true, targetEmail: settings.notificationEmail || settings.email || 'info@megahealthgroup.org', sending: false, result: '', error: '' })}
                >
                  🧪 Send Test Mail
                </button>
              </div>
            </div>

            {/* Mail & Contact Page Settings Panel */}
            <div className="card admin-form" style={{ padding: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
                <div>
                  <h3 style={{ margin: 0, fontSize: '1.25rem' }}>Mail Notifications & Contact Settings</h3>
                  <p style={{ margin: '4px 0 0 0', fontSize: '0.85rem', color: 'var(--muted)' }}>
                    Configure notification alerts, auto-acknowledgement emails, and public contact information.
                  </p>
                </div>
                <button type="button" className="btn btn-primary btn-sm" onClick={handleSettingsSubmit}>
                  Save Settings Changes
                </button>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div className="form-group">
                  <label>Notification Recipient Email (Admin Alert Address)</label>
                  <input
                    type="email"
                    value={settings.notificationEmail || ''}
                    onChange={e => setSettings(s => ({ ...s, notificationEmail: e.target.value }))}
                    placeholder="e.g. info@megahealthgroup.org"
                  />
                </div>
                <div className="form-group">
                  <label>Public Contact Phone / Hotline</label>
                  <input
                    value={settings.phone || ''}
                    onChange={e => setSettings(s => ({ ...s, phone: e.target.value }))}
                    placeholder="+91 965439 1410"
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginTop: 10 }}>
                <div style={{ background: 'var(--bg-light)', padding: 14, borderRadius: 8, border: '1px solid var(--border)' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}>
                    <input
                      type="checkbox"
                      checked={settings.enableEmailNotification !== false}
                      onChange={e => setSettings(s => ({ ...s, enableEmailNotification: e.target.checked }))}
                      style={{ width: 18, height: 18 }}
                    />
                    Send Email Alert to Admin on New Enquiry
                  </label>
                  <p style={{ margin: '4px 0 0 28px', fontSize: '0.78rem', color: 'var(--muted)' }}>
                    Automatically emails the notification recipient whenever a visitor submits a contact/booking form.
                  </p>
                </div>

                <div style={{ background: 'var(--bg-light)', padding: 14, borderRadius: 8, border: '1px solid var(--border)' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}>
                    <input
                      type="checkbox"
                      checked={settings.enableUserConfirmation !== false}
                      onChange={e => setSettings(s => ({ ...s, enableUserConfirmation: e.target.checked }))}
                      style={{ width: 18, height: 18 }}
                    />
                    Send Auto-Confirmation Email to Patient
                  </label>
                  <p style={{ margin: '4px 0 0 28px', fontSize: '0.78rem', color: 'var(--muted)' }}>
                    Sends an automated receipt email with appointment summary if the visitor enters their email address.
                  </p>
                </div>
              </div>

              {/* Optional SMTP Config Collapsible */}
              <details style={{ marginTop: 16, background: '#fafafa', padding: 14, borderRadius: 8, border: '1px solid var(--border)' }}>
                <summary style={{ fontWeight: 700, cursor: 'pointer', fontSize: '0.9rem', color: 'var(--teal-dark)' }}>
                  ⚙️ Advanced SMTP Server Settings (Optional)
                </summary>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr 2fr', gap: 14, marginTop: 16 }}>
                  <div className="form-group">
                    <label>SMTP Host</label>
                    <input
                      value={settings.smtpHost || ''}
                      onChange={e => setSettings(s => ({ ...s, smtpHost: e.target.value }))}
                      placeholder="e.g. mail.megahealthgroup.org"
                    />
                  </div>
                  <div className="form-group">
                    <label>Port</label>
                    <input
                      type="number"
                      value={settings.smtpPort || 587}
                      onChange={e => setSettings(s => ({ ...s, smtpPort: parseInt(e.target.value) || 587 }))}
                      placeholder="587"
                    />
                  </div>
                  <div className="form-group">
                    <label>SMTP Username</label>
                    <input
                      value={settings.smtpUser || ''}
                      onChange={e => setSettings(s => ({ ...s, smtpUser: e.target.value }))}
                      placeholder="user@domain.com"
                    />
                  </div>
                  <div className="form-group">
                    <label>SMTP Password</label>
                    <input
                      type="password"
                      value={settings.smtpPass || ''}
                      onChange={e => setSettings(s => ({ ...s, smtpPass: e.target.value }))}
                      placeholder="••••••••"
                    />
                  </div>
                </div>
              </details>
            </div>

            {/* Enquiries Table Panel with Filtering */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
                <h3 style={{ margin: 0, fontSize: '1.35rem', color: 'var(--teal-dark)' }}>
                  Incoming Patient Enquiries & Bookings
                </h3>
                
                {/* Status Filter Pills */}
                <div style={{ display: 'flex', gap: 6, background: 'var(--white)', padding: 4, borderRadius: 8, border: '1px solid var(--border)' }}>
                  {['all', 'new', 'read', 'replied'].map(st => (
                    <button
                      key={st}
                      type="button"
                      onClick={() => setContactFilter(st)}
                      style={{
                        padding: '6px 14px',
                        borderRadius: 6,
                        border: 'none',
                        background: contactFilter === st ? 'var(--teal-primary)' : 'transparent',
                        color: contactFilter === st ? 'white' : 'var(--dark)',
                        fontWeight: 600,
                        fontSize: '0.82rem',
                        cursor: 'pointer',
                        textTransform: 'capitalize'
                      }}
                    >
                      {st === 'all' ? `All (${contacts.length})` : st === 'new' ? `New (${contacts.filter(c => c.status === 'new').length})` : st === 'read' ? `Read (${contacts.filter(c => c.status === 'read').length})` : `Replied (${contacts.filter(c => c.status === 'replied').length})`}
                    </button>
                  ))}
                </div>
              </div>

              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Patient Name</th>
                      <th>Contact Details</th>
                      <th>Service Required</th>
                      <th>Preferred Slot</th>
                      <th>Status</th>
                      <th style={{ width: 220 }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contacts.filter(c => contactFilter === 'all' || c.status === contactFilter).length === 0 ? (
                      <tr><td colSpan="6" style={{ textAlign: 'center', padding: 30, color: 'var(--muted)' }}>No contact enquiries found for this filter.</td></tr>
                    ) : (
                      contacts
                        .filter(c => contactFilter === 'all' || c.status === contactFilter)
                        .map(item => (
                          <tr key={item.id || item._id} style={{ opacity: item.status === 'read' ? 0.8 : 1 }}>
                            <td style={{ fontWeight: 700 }}>
                              {item.firstName} {item.lastName}
                            </td>
                            <td>
                              <div>📞 {item.phone}</div>
                              {item.email ? <div style={{ fontSize: '0.8rem', color: 'var(--teal-primary)' }}>✉ {item.email}</div> : <span style={{ fontSize: '0.75rem', color: 'var(--muted)' }}>No email</span>}
                            </td>
                            <td>
                              <span style={{ fontWeight: 600 }}>{item.service}</span>
                            </td>
                            <td>
                              <div>📅 {item.preferredDate || 'Flexible'}</div>
                              <div style={{ fontSize: '0.78rem', color: 'var(--muted)' }}>🕒 {item.preferredTime}</div>
                            </td>
                            <td>
                              <span style={{
                                background: item.status === 'new' ? 'var(--gold-light)' : item.status === 'replied' ? 'var(--teal-soft)' : 'var(--border)',
                                color: item.status === 'new' ? 'var(--gold-primary)' : item.status === 'replied' ? 'var(--teal-primary)' : 'var(--dark)',
                                padding: '4px 10px',
                                borderRadius: 50,
                                fontSize: '0.72rem',
                                fontWeight: 700,
                                textTransform: 'uppercase'
                              }}>
                                {item.status}
                              </span>
                            </td>
                            <td>
                              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                <button
                                  type="button"
                                  className="btn-icon btn-icon-secondary btn-icon-sm"
                                  onClick={() => setSelectedContactModal(item)}
                                  title="View Full Details"
                                >
                                  <IconEye size={14} /> Details
                                </button>

                                {item.email && (
                                  <button
                                    type="button"
                                    className="btn-icon btn-icon-primary btn-icon-sm"
                                    onClick={() => openReplyModal(item)}
                                    title="Reply via Email"
                                  >
                                    <IconMail size={14} /> Reply
                                  </button>
                                )}

                                <button
                                  type="button"
                                  className="btn-icon btn-icon-secondary btn-icon-sm"
                                  onClick={() => toggleContactStatus(item.id || item._id, item.status)}
                                >
                                  {item.status === 'new' ? 'Read' : 'New'}
                                </button>

                                <button
                                  type="button"
                                  className="btn-icon btn-icon-danger btn-icon-sm"
                                  onClick={() => deleteItem('contact', item.id || item._id)}
                                >
                                  <IconTrash size={14} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        )}

        {/* Donation enquiries tracking */}
        {!loading && section === 'donations' && (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Contact Info</th>
                  <th>Amount</th>
                  <th>Payment Type</th>
                  <th>Submission Date</th>
                  <th>Status</th>
                  <th style={{ width: 180 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {donations.length === 0 ? (
                  <tr><td colSpan="7" style={{ textAlign: 'center', color: 'var(--muted)' }}>No donation inquiries found.</td></tr>
                ) : (
                  donations.map(item => (
                    <tr key={item.id || item._id} style={{ opacity: item.status === 'read' ? 0.75 : 1 }}>
                      <td style={{ fontWeight: 600 }}>{item.name}</td>
                      <td>{item.email || '—'}<br/>{item.phone || '—'}</td>
                      <td style={{ fontWeight: 700, color: 'var(--gold-primary)' }}>{item.amount || 'Custom'}</td>
                      <td>{item.donationType}</td>
                      <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                      <td>
                        <span style={{ background: item.status === 'new' ? 'var(--gold-light)' : 'var(--border)', padding: '4px 10px', borderRadius: 50, fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase' }}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            style={{ padding: '6px 12px' }}
                            onClick={() => toggleDonationStatus(item.id || item._id, item.status)}
                          >
                            {item.status === 'new' ? 'Read' : 'New'}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            style={{ padding: '6px 12px', borderColor: 'var(--danger)', color: 'var(--danger)' }}
                            onClick={() => deleteItem('donation', item.id || item._id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Gallery items management */}
        {!loading && section === 'gallery' && (
          <div style={{ display: 'grid', gap: 32 }}>
            <form className="admin-card-form" onSubmit={handleGallerySubmit}>
              <div className="admin-card-form-header">
                <div>
                  <h3><IconCamera size={22} color="#0F766E" /> {editingId ? 'Edit Gallery Photo' : 'Add New Gallery Photo'}</h3>
                  <p>Upload photography of medical camps, facilities, and community health drives.</p>
                </div>
                {editingId && (
                  <button type="button" onClick={cancelEdit} className="btn-icon btn-icon-secondary btn-icon-sm">
                    Cancel Editing
                  </button>
                )}
              </div>

              <div className="admin-form-group">
                <label>Photo Title <span className="req">*</span></label>
                <input
                  className="admin-input"
                  value={galleryForm.title}
                  onChange={e => setGalleryForm(f => ({ ...f, title: e.target.value }))}
                  placeholder="e.g. Free Eye Screening Camp..."
                  required
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div className="admin-form-group">
                  <label>Category Tag</label>
                  <select
                    className="admin-select"
                    value={galleryForm.category}
                    onChange={e => setGalleryForm(f => ({ ...f, category: e.target.value }))}
                  >
                    <option value="Facility">Facility & Equipment</option>
                    <option value="Services">Medical Services</option>
                    <option value="Events">Charity Events</option>
                    <option value="General">General</option>
                  </select>
                </div>

                <div className="admin-form-group">
                  <label>Photo Image URL</label>
                  <input
                    className="admin-input"
                    type="url"
                    value={galleryForm.imageUrl && !galleryForm.imageUrl.startsWith('data:') ? galleryForm.imageUrl : ''}
                    onChange={e => setGalleryForm(f => ({ ...f, imageUrl: e.target.value }))}
                    placeholder="https://example.com/photo.jpg"
                  />
                </div>
              </div>

              <div className="admin-form-group">
                <label>Or Upload Photo File</label>
                <div className="admin-dropzone">
                  <input
                    type="file"
                    id="gallery-file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, setGalleryForm)}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="gallery-file" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="admin-dropzone-icon">
                      <IconCloudUpload size={28} />
                    </div>
                    <div style={{ fontWeight: 700, fontSize: '0.9rem', color: '#0F172A' }}>
                      Click to upload photo file
                    </div>
                    <div style={{ fontSize: '0.78rem', color: '#64748B' }}>
                      PNG, JPG, WebP up to 5MB
                    </div>
                  </label>
                  {galleryForm.imageUrl && (
                    <div style={{ marginTop: 12, borderRadius: 10, overflow: 'hidden', height: 80, border: '1px solid #E2E8F0' }}>
                      <img src={galleryForm.imageUrl} alt="preview" style={{ height: '100%', objectFit: 'cover' }} />
                    </div>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                <button type="submit" className="btn-icon btn-icon-primary">
                  <IconPlus size={18} /> {editingId ? 'Update Photo' : 'Save & Publish Photo'}
                </button>
              </div>
            </form>

            <div>
              <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#0F172A', marginBottom: 20 }}>Existing Photos ({gallery.length})</h3>
              <div className="gallery-masonry">
                {gallery.map(item => (
                  <div key={item.id || item._id} className="gallery-card">
                    <div className="gallery-thumb">
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt={item.title} />
                      ) : (
                        <div style={{ padding: 20, color: '#64748B' }}><IconCamera size={40} /></div>
                      )}
                    </div>
                    <div className="gallery-card-body" style={{ padding: 18 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                        <div className="date">{item.category}</div>
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: item.published ? '#CCFBF1' : '#FEF3C7', color: item.published ? '#0F766E' : '#92400E' }}>
                          {item.published ? 'Published' : 'Hidden'}
                        </span>
                      </div>
                      <h4 style={{ fontSize: '1.05rem', margin: '4px 0 12px' }}>{item.title}</h4>
                      <div style={{ display: 'flex', gap: 6, marginTop: 'auto' }}>
                        <button type="button" className="btn-icon btn-icon-secondary btn-icon-sm" style={{ flexGrow: 1 }} onClick={() => startEditGallery(item)}><IconPencil size={14} /> Edit</button>
                        <button
                          type="button"
                          className="btn-icon btn-icon-secondary btn-icon-sm"
                          style={{ flexGrow: 1 }}
                          onClick={() => api.put(`/gallery/${item.id || item._id}`, { ...item, published: item.published ? 0 : 1 }).then(loadAll)}
                        >{item.published ? 'Hide' : 'Publish'}</button>
                        <button type="button" className="btn-icon btn-icon-danger btn-icon-sm" onClick={() => deleteItem('gallery', item.id || item._id)}><IconTrash size={14} /></button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Upcoming and Past events management */}
        {!loading && (section === 'events' || section === 'past-events') && (
          <div style={{ display: 'grid', gap: 32 }}>
            <form className="admin-card-form" onSubmit={handleEventSubmit}>
              <div className="admin-card-form-header">
                <div>
                  <h3>
                    <IconCalendar size={22} color="#0F766E" />
                    {editingId ? `Edit ${section === 'past-events' ? 'Past' : 'Upcoming'} Event` : `Add ${section === 'past-events' ? 'Past' : 'Upcoming'} Event`}
                  </h3>
                  <p>Publish health drives, medical camps, and community initiatives.</p>
                </div>
                {editingId && (
                  <button type="button" onClick={cancelEdit} className="btn-icon btn-icon-secondary btn-icon-sm">
                    Cancel Editing
                  </button>
                )}
              </div>
              
              <div className="admin-form-group">
                <label>Event / Activity Title <span className="req">*</span></label>
                <input
                  className="admin-input"
                  value={eventForm.title}
                  onChange={e => setEventForm(f => ({ ...f, title: e.target.value }))}
                  placeholder="e.g. Free Eye Screening Camp..."
                  required
                />
              </div>

              <div className="admin-form-group">
                <label>Description <span className="req">*</span></label>
                <textarea
                  className="admin-textarea"
                  value={eventForm.description}
                  onChange={e => setEventForm(f => ({ ...f, description: e.target.value }))}
                  placeholder="Event details, target audience, schedules..."
                  required
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div className="admin-form-group">
                  <label>Event Date <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={eventForm.date}
                    onChange={e => setEventForm(f => ({ ...f, date: e.target.value }))}
                    placeholder="e.g. Oct 15, 2026"
                    required
                  />
                </div>
                <div className="admin-form-group">
                  <label>Location / Venue <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={eventForm.location}
                    onChange={e => setEventForm(f => ({ ...f, location: e.target.value }))}
                    placeholder="e.g. Clinic Hall, Outdoor Camp"
                    required
                  />
                </div>
              </div>

              <div className="admin-form-group">
                <label>Banner Image URL</label>
                <input
                  className="admin-input"
                  type="url"
                  value={eventForm.imageUrl && !eventForm.imageUrl.startsWith('data:') ? eventForm.imageUrl : ''}
                  onChange={e => setEventForm(f => ({ ...f, imageUrl: e.target.value }))}
                  placeholder="https://example.com/banner.jpg"
                />
              </div>

              <div className="admin-form-group">
                <label>Or Upload Banner File</label>
                <div className="admin-dropzone">
                  <input
                    type="file"
                    id="event-file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, setEventForm)}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="event-file" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="admin-dropzone-icon">
                      <IconCloudUpload size={28} />
                    </div>
                    <div style={{ fontWeight: 700, fontSize: '0.9rem', color: '#0F172A' }}>
                      Click to upload banner photo
                    </div>
                  </label>
                  {eventForm.imageUrl && (
                    <div style={{ marginTop: 12, borderRadius: 10, overflow: 'hidden', height: 80, border: '1px solid #E2E8F0' }}>
                      <img src={eventForm.imageUrl} alt="preview" style={{ height: '100%', objectFit: 'cover' }} />
                    </div>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                <button type="submit" className="btn-icon btn-icon-primary">
                  <IconPlus size={18} /> {editingId ? 'Update Event' : 'Publish Event'}
                </button>
              </div>
            </form>

            <div>
              <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#0F172A', marginBottom: 20 }}>Existing Events ({events.filter(e => e.type === (section === 'past-events' ? 'past' : 'future')).length})</h3>
              <div style={{ display: 'grid', gap: 16 }}>
                {events.filter(e => e.type === (section === 'past-events' ? 'past' : 'future')).map(item => (
                  <div key={item.id || item._id} className="admin-card" style={{ display: 'flex', gap: 20, padding: 20, flexWrap: 'wrap', alignItems: 'center' }}>
                    <div className="preview-thumb" style={{ width: 72, height: 72, flexShrink: 0, borderRadius: 12, background: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 12 }} />
                      ) : (
                        <IconCalendar size={32} color="#0F766E" />
                      )}
                    </div>
                    <div style={{ flexGrow: 1, minWidth: 240 }}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                        <h4 style={{ fontSize: '1.1rem', margin: 0, fontWeight: 700, color: '#0F172A' }}>{item.title}</h4>
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: item.published ? '#CCFBF1' : '#FEF3C7', color: item.published ? '#0F766E' : '#92400E' }}>
                          {item.published ? 'Published' : 'Hidden'}
                        </span>
                      </div>
                      <p style={{ fontSize: '0.88rem', margin: '4px 0', color: '#475569' }}>{item.description}</p>
                      <div style={{ fontSize: '0.8rem', color: '#0F766E', fontWeight: 700, display: 'flex', gap: 12, marginTop: 6 }}>
                        <span>📅 {item.date}</span>
                        <span>📍 {item.location}</span>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button type="button" className="btn-icon btn-icon-secondary btn-icon-sm" onClick={() => startEditEvent(item)}><IconPencil size={14} /> Edit</button>
                      <button
                        type="button"
                        className="btn-icon btn-icon-secondary btn-icon-sm"
                        onClick={() => api.put(`/events/${item.id || item._id}`, { ...item, published: item.published ? 0 : 1 }).then(loadAll)}
                      >
                        {item.published ? 'Hide' : 'Publish'}
                      </button>
                      <button type="button" className="btn-icon btn-icon-danger btn-icon-sm" onClick={() => deleteItem('events', item.id || item._id)}><IconTrash size={14} /></button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Press Releases management */}
        {!loading && section === 'press' && (
          <div style={{ display: 'grid', gap: 32 }}>
            <form className="admin-card-form" onSubmit={handlePressSubmit}>
              <div className="admin-card-form-header">
                <div>
                  <h3>
                    <IconNewspaper size={22} color="#0F766E" />
                    {editingId ? 'Edit Press Release' : 'Add Press Release'}
                  </h3>
                  <p>Publish official press releases, news updates, and media announcements.</p>
                </div>
                {editingId && (
                  <button type="button" onClick={cancelEdit} className="btn-icon btn-icon-secondary btn-icon-sm">
                    Cancel Editing
                  </button>
                )}
              </div>

              <div className="admin-form-group">
                <label>Release Title <span className="req">*</span></label>
                <input
                  className="admin-input"
                  value={pressForm.title}
                  onChange={e => setPressForm(f => ({ ...f, title: e.target.value }))}
                  placeholder="e.g. ISO Laboratory Certification Achieved..."
                  required
                />
              </div>

              <div className="admin-form-group">
                <label>Summary (Preview Snippet) <span className="req">*</span></label>
                <textarea
                  className="admin-textarea"
                  value={pressForm.summary}
                  onChange={e => setPressForm(f => ({ ...f, summary: e.target.value }))}
                  placeholder="Provide a brief 1-2 sentence preview..."
                  required
                />
              </div>

              <div className="admin-form-group">
                <label>Full Content Body</label>
                <textarea
                  className="admin-textarea"
                  value={pressForm.content}
                  onChange={e => setPressForm(f => ({ ...f, content: e.target.value }))}
                  placeholder="Complete press release body..."
                  style={{ minHeight: 160 }}
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div className="admin-form-group">
                  <label>Release Date <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    type="date"
                    value={pressForm.date}
                    onChange={e => setPressForm(f => ({ ...f, date: e.target.value }))}
                    required
                  />
                </div>
                <div className="admin-form-group">
                  <label>Featured Image URL</label>
                  <input
                    className="admin-input"
                    type="url"
                    value={pressForm.imageUrl && !pressForm.imageUrl.startsWith('data:') ? pressForm.imageUrl : ''}
                    onChange={e => setPressForm(f => ({ ...f, imageUrl: e.target.value }))}
                    placeholder="https://example.com/press.jpg"
                  />
                </div>
              </div>

              <div className="admin-form-group">
                <label>Or Upload Featured Image File</label>
                <div className="admin-dropzone">
                  <input
                    type="file"
                    id="press-file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, setPressForm)}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="press-file" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="admin-dropzone-icon">
                      <IconCloudUpload size={28} />
                    </div>
                    <div style={{ fontWeight: 700, fontSize: '0.9rem', color: '#0F172A' }}>
                      Click to upload featured image
                    </div>
                  </label>
                  {pressForm.imageUrl && (
                    <div style={{ marginTop: 12, borderRadius: 10, overflow: 'hidden', height: 80, border: '1px solid #E2E8F0' }}>
                      <img src={pressForm.imageUrl} alt="preview" style={{ height: '100%', objectFit: 'cover' }} />
                    </div>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                <button type="submit" className="btn-icon btn-icon-primary">
                  <IconPlus size={18} /> {editingId ? 'Update Release' : 'Publish Release'}
                </button>
              </div>
            </form>

            <div>
              <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#0F172A', marginBottom: 20 }}>Existing Releases ({press.length})</h3>
              <div style={{ display: 'grid', gap: 16 }}>
                {press.map(item => (
                  <div key={item.id || item._id} className="admin-card" style={{ display: 'flex', gap: 20, padding: 20, flexWrap: 'wrap', alignItems: 'center' }}>
                    <div className="preview-thumb" style={{ width: 72, height: 72, flexShrink: 0, borderRadius: 12, background: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 12 }} />
                      ) : (
                        <IconNewspaper size={32} color="#0F766E" />
                      )}
                    </div>
                    <div style={{ flexGrow: 1, minWidth: 240 }}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                        <h4 style={{ fontSize: '1.1rem', margin: 0, fontWeight: 700, color: '#0F172A' }}>{item.title}</h4>
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: item.published ? '#CCFBF1' : '#FEF3C7', color: item.published ? '#0F766E' : '#92400E' }}>
                          {item.published ? 'Published' : 'Hidden'}
                        </span>
                      </div>
                      <p style={{ fontSize: '0.88rem', margin: '4px 0', color: '#475569' }}>{item.summary}</p>
                      <span style={{ fontSize: '0.8rem', color: '#0F766E', fontWeight: 700 }}>
                        📅 {item.date}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button type="button" className="btn-icon btn-icon-secondary btn-icon-sm" onClick={() => startEditPress(item)}><IconPencil size={14} /> Edit</button>
                      <button
                        type="button"
                        className="btn-icon btn-icon-secondary btn-icon-sm"
                        onClick={() => api.put(`/press/${item.id || item._id}`, { ...item, published: item.published ? 0 : 1 }).then(loadAll)}
                      >
                        {item.published ? 'Hide' : 'Publish'}
                      </button>
                      <button type="button" className="btn-icon btn-icon-danger btn-icon-sm" onClick={() => deleteItem('press', item.id || item._id)}><IconTrash size={14} /></button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Site settings management */}
        {!loading && section === 'settings' && (
          <div style={{ display: 'grid', gap: 32 }}>
            <form className="admin-card-form" onSubmit={handleSettingsSubmit} style={{ maxWidth: 900 }}>
              <div className="admin-card-form-header">
                <div>
                  <h3>Manage Site & Contact Settings</h3>
                  <p>Updates header info, footer details, maps frames, and banking info panels instantaneously.</p>
                </div>
                <button type="submit" className="btn-icon btn-icon-primary">
                  Save All Settings
                </button>
              </div>
            
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div className="admin-form-group">
                  <label>Hotline Telephone <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={settings.phone || ''}
                    onChange={e => setSettings(s => ({ ...s, phone: e.target.value }))}
                    placeholder="e.g. 05368 297433"
                    required
                  />
                </div>
                <div className="admin-form-group">
                  <label>Primary Contact Email <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    type="email"
                    value={settings.email || ''}
                    onChange={e => setSettings(s => ({ ...s, email: e.target.value }))}
                    placeholder="e.g. info@megahealthgroup.org"
                    required
                  />
                </div>
              </div>

              <div className="admin-form-group">
                <label>Additional Email Support (HR, Support Gmails, etc.)</label>
                <input
                  className="admin-input"
                  value={settings.secondaryEmail || ''}
                  onChange={e => setSettings(s => ({ ...s, secondaryEmail: e.target.value }))}
                  placeholder="e.g. HR@megahealthgroup.org, Megafoundation022@gmail.com"
                />
                <span style={{ fontSize: '0.78rem', color: '#64748B', marginTop: 4 }}>
                  Separate multiple emails with commas. These appear under Email Support on the Contact page.
                </span>
              </div>

              <div className="admin-form-group">
                <label>Clinic Address <span className="req">*</span></label>
                <input
                  className="admin-input"
                  value={settings.address}
                  onChange={e => setSettings(s => ({ ...s, address: e.target.value }))}
                  placeholder="e.g. Mega Health Group Hospital, Main Rd..."
                  required
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div className="admin-form-group">
                  <label>WhatsApp Chat URL <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={settings.whatsapp}
                    onChange={e => setSettings(s => ({ ...s, whatsapp: e.target.value }))}
                    placeholder="e.g. https://wa.me/919654391410"
                    required
                  />
                </div>
                <div className="admin-form-group">
                  <label>Business Operating Hours <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={settings.hours}
                    onChange={e => setSettings(s => ({ ...s, hours: e.target.value }))}
                    placeholder="e.g. Mon–Sat: 8:00 AM – 8:00 PM"
                    required
                  />
                </div>
              </div>

              <div className="admin-form-group">
                <label>Google Maps Embed URL <span className="req">*</span></label>
                <textarea
                  className="admin-textarea"
                  value={settings.googleMapsUrl}
                  onChange={e => setSettings(s => ({ ...s, googleMapsUrl: e.target.value }))}
                  placeholder="Paste Google Maps iframe src URL here..."
                  style={{ minHeight: 70 }}
                  required
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginTop: 12 }}>
                <div className="admin-form-group">
                  <label>Facebook Link</label>
                  <input
                    className="admin-input"
                    value={settings.facebookUrl}
                    onChange={e => setSettings(s => ({ ...s, facebookUrl: e.target.value }))}
                    placeholder="https://facebook.com/..."
                  />
                </div>
                <div className="admin-form-group">
                  <label>Instagram Link</label>
                  <input
                    className="admin-input"
                    value={settings.instagramUrl}
                    onChange={e => setSettings(s => ({ ...s, instagramUrl: e.target.value }))}
                    placeholder="https://instagram.com/..."
                  />
                </div>
                <div className="admin-form-group">
                  <label>YouTube Link</label>
                  <input
                    className="admin-input"
                    value={settings.youtubeUrl}
                    onChange={e => setSettings(s => ({ ...s, youtubeUrl: e.target.value }))}
                    placeholder="https://youtube.com/..."
                  />
                </div>
              </div>

              <h4 style={{ color: '#0F172A', fontSize: '1.1rem', margin: '28px 0 16px', borderBottom: '1px solid #E2E8F0', paddingBottom: 10, fontWeight: 800 }}>
                Charity & Bank Donation Details
              </h4>

              <div className="admin-form-group">
                <label>Donation Page Intro Message</label>
                <textarea
                  className="admin-textarea"
                  value={settings.donationMessage}
                  onChange={e => setSettings(s => ({ ...s, donationMessage: e.target.value }))}
                  placeholder="Introduce charity camp fundraising objectives..."
                  style={{ minHeight: 75 }}
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div className="admin-form-group">
                  <label>Bank Name <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={settings.bankName}
                    onChange={e => setSettings(s => ({ ...s, bankName: e.target.value }))}
                    placeholder="e.g. State Bank of India"
                    required
                  />
                </div>
                <div className="admin-form-group">
                  <label>Account Name <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={settings.bankAccountName}
                    onChange={e => setSettings(s => ({ ...s, bankAccountName: e.target.value }))}
                    placeholder="e.g. Mega Health Group Trust"
                    required
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
                <div className="admin-form-group">
                  <label>Account Number <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={settings.bankAccountNumber}
                    onChange={e => setSettings(s => ({ ...s, bankAccountNumber: e.target.value }))}
                    placeholder="e.g. 012345678901"
                    required
                  />
                </div>
                <div className="admin-form-group">
                  <label>IFSC Code <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={settings.bankIfsc}
                    onChange={e => setSettings(s => ({ ...s, bankIfsc: e.target.value }))}
                    placeholder="e.g. SBIN0001234"
                    required
                  />
                </div>
                <div className="admin-form-group">
                  <label>Branch <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={settings.bankBranch}
                    onChange={e => setSettings(s => ({ ...s, bankBranch: e.target.value }))}
                    placeholder="e.g. Amethi Main Branch"
                    required
                  />
                </div>
              </div>

              <div style={{ marginTop: 24 }}>
                <button type="submit" className="btn-icon btn-icon-primary">
                  Save All Settings
                </button>
              </div>
            </form>

            <form className="admin-card-form" onSubmit={handleChangePassword} style={{ maxWidth: 500 }}>
              <div className="admin-card-form-header">
                <div>
                  <h3>Change Admin Password</h3>
                  <p>Update system security credentials.</p>
                </div>
              </div>

              <div className="admin-form-group">
                <label>Current Password <span className="req">*</span></label>
                <input
                  className="admin-input"
                  type="password"
                  value={pwForm.currentPassword}
                  onChange={e => setPwForm(f => ({ ...f, currentPassword: e.target.value }))}
                  required
                />
              </div>
              <div className="admin-form-group">
                <label>New Password <span className="req">*</span></label>
                <input
                  className="admin-input"
                  type="password"
                  value={pwForm.newPassword}
                  onChange={e => setPwForm(f => ({ ...f, newPassword: e.target.value }))}
                  required
                />
              </div>
              <div className="admin-form-group">
                <label>Confirm New Password <span className="req">*</span></label>
                <input
                  className="admin-input"
                  type="password"
                  value={pwForm.confirmPassword}
                  onChange={e => setPwForm(f => ({ ...f, confirmPassword: e.target.value }))}
                  required
                />
              </div>
              {pwMessage && (
                <p style={{ fontWeight: 600, fontSize: '0.88rem', color: pwMessage.startsWith('✓') ? '#0F766E' : 'var(--danger)', margin: '8px 0 0' }}>
                  {pwMessage}
                </p>
              )}
              <button type="submit" className="btn-icon btn-icon-primary" style={{ marginTop: 12 }}>
                Update Password
              </button>
            </form>
          </div>
        )}

        {/* Detail View Modal */}
        {selectedContactModal && (
          <div className="admin-modal-overlay" onClick={() => setSelectedContactModal(null)}>
            <div className="admin-modal" onClick={e => e.stopPropagation()}>
              <div className="admin-modal-header">
                <h3>Enquiry Details: {selectedContactModal.firstName} {selectedContactModal.lastName}</h3>
                <button className="admin-modal-close" onClick={() => setSelectedContactModal(null)}>✕</button>
              </div>
              <div style={{ display: 'grid', gap: 14, fontSize: '0.92rem' }}>
                <div><strong>Patient Name:</strong> {selectedContactModal.firstName} {selectedContactModal.lastName}</div>
                <div><strong>Phone Number:</strong> <a href={`tel:${selectedContactModal.phone}`}>{selectedContactModal.phone}</a></div>
                <div><strong>Email Address:</strong> {selectedContactModal.email ? <a href={`mailto:${selectedContactModal.email}`}>{selectedContactModal.email}</a> : 'None provided'}</div>
                <div><strong>Medical Specialty:</strong> {selectedContactModal.service}</div>
                <div><strong>Preferred Date:</strong> {selectedContactModal.preferredDate || 'Not specified'}</div>
                <div><strong>Preferred Time Slot:</strong> {selectedContactModal.preferredTime || 'Any available time'}</div>
                <div><strong>Submission Date:</strong> {new Date(selectedContactModal.createdAt).toLocaleString()}</div>
                <div>
                  <strong>Status:</strong>{' '}
                  <span style={{ textTransform: 'uppercase', fontWeight: 700, color: 'var(--gold-primary)' }}>{selectedContactModal.status}</span>
                </div>
                <div style={{ background: '#f9f9f9', padding: 14, borderRadius: 8, borderLeft: '4px solid var(--teal-primary)', marginTop: 8 }}>
                  <strong>Patient Message / Clinical Concerns:</strong>
                  <p style={{ margin: '8px 0 0 0', whiteSpace: 'pre-wrap' }}>{selectedContactModal.message || 'No additional notes entered.'}</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10, marginTop: 24, justifyContent: 'flex-end' }}>
                {selectedContactModal.email && (
                  <button
                    type="button"
                    className="btn-icon btn-icon-primary"
                    onClick={() => {
                      const c = selectedContactModal;
                      setSelectedContactModal(null);
                      openReplyModal(c);
                    }}
                  >
                    <IconMail size={16} /> Reply via Email
                  </button>
                )}
                <button type="button" className="btn-icon btn-icon-secondary" onClick={() => setSelectedContactModal(null)}>Close</button>
              </div>
            </div>
          </div>
        )}

        {/* Reply Email Modal */}
        {replyModal.open && (
          <div className="admin-modal-overlay" onClick={() => setReplyModal(r => ({ ...r, open: false }))}>
            <div className="admin-modal" onClick={e => e.stopPropagation()}>
              <div className="admin-modal-header">
                <h3 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <IconMail size={20} color="#0F766E" /> Compose Email Reply
                </h3>
                <button className="admin-modal-close" onClick={() => setReplyModal(r => ({ ...r, open: false }))}>✕</button>
              </div>
              <form onSubmit={handleSendReply}>
                <div className="admin-form-group" style={{ marginBottom: 14 }}>
                  <label>To Patient</label>
                  <input className="admin-input" value={`${replyModal.contact?.firstName} ${replyModal.contact?.lastName} <${replyModal.contact?.email}>`} disabled />
                </div>
                <div className="admin-form-group" style={{ marginBottom: 14 }}>
                  <label>Subject <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    value={replyModal.subject}
                    onChange={e => setReplyModal(r => ({ ...r, subject: e.target.value }))}
                    required
                  />
                </div>
                <div className="admin-form-group" style={{ marginBottom: 16 }}>
                  <label>Message Body <span className="req">*</span></label>
                  <textarea
                    className="admin-textarea"
                    value={replyModal.message}
                    onChange={e => setReplyModal(r => ({ ...r, message: e.target.value }))}
                    style={{ minHeight: 180 }}
                    required
                  />
                </div>

                {replyModal.error && <p style={{ color: 'var(--danger)', fontWeight: 600, fontSize: '0.88rem' }}>{replyModal.error}</p>}
                {replyModal.success && <p style={{ color: '#0F766E', fontWeight: 600, fontSize: '0.88rem' }}>{replyModal.success}</p>}

                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
                  <button type="button" className="btn-icon btn-icon-secondary" onClick={() => setReplyModal(r => ({ ...r, open: false }))}>Cancel</button>
                  <button type="submit" className="btn-icon btn-icon-primary" disabled={replyModal.sending}>
                    <IconMail size={16} /> {replyModal.sending ? 'Sending Email...' : 'Send Reply Email'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Test Email Modal */}
        {testEmailModal.open && (
          <div className="admin-modal-overlay" onClick={() => setTestEmailModal(t => ({ ...t, open: false }))}>
            <div className="admin-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }}>
              <div className="admin-modal-header">
                <h3 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <IconTest size={20} color="#0F766E" /> Test Mail Notification
                </h3>
                <button className="admin-modal-close" onClick={() => setTestEmailModal(t => ({ ...t, open: false }))}>✕</button>
              </div>
              <form onSubmit={handleSendTestEmail}>
                <p style={{ fontSize: '0.88rem', margin: '0 0 16px 0', color: '#64748B' }}>
                  Enter a destination email address to verify that your mail server configuration can send messages successfully.
                </p>
                <div className="admin-form-group" style={{ marginBottom: 16 }}>
                  <label>Destination Email Address <span className="req">*</span></label>
                  <input
                    className="admin-input"
                    type="email"
                    value={testEmailModal.targetEmail}
                    onChange={e => setTestEmailModal(t => ({ ...t, targetEmail: e.target.value }))}
                    placeholder="e.g. yourname@example.com"
                    required
                  />
                </div>

                {testEmailModal.error && <p style={{ color: 'var(--danger)', fontWeight: 600, fontSize: '0.88rem' }}>{testEmailModal.error}</p>}
                {testEmailModal.result && <p style={{ color: '#0F766E', fontWeight: 600, fontSize: '0.88rem' }}>{testEmailModal.result}</p>}

                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
                  <button type="button" className="btn-icon btn-icon-secondary" onClick={() => setTestEmailModal(t => ({ ...t, open: false }))}>Close</button>
                  <button type="submit" className="btn-icon btn-icon-primary" disabled={testEmailModal.sending}>
                    <IconTest size={16} /> {testEmailModal.sending ? 'Dispatching...' : 'Send Test Mail'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default Admin;
